/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Body_delete_user_file_by_prefix_api_v1_user_folder_file_object_by_prefix_post */
export interface BodyDeleteUserFileByPrefixApiV1UserFolderFileObjectByPrefixPost {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Storage Info */
    storage_info: Record<string, any>[]
}

/** Body_fo_presign_post_api_v1_user_folder_file_object_presign_post_post */
export interface BodyFoPresignPostApiV1UserFolderFileObjectPresignPostPost {
    /** Filename */
    filename: string
    /**
     * Filesize
     * @default 0
     */
    filesize?: number
    life_type: FileLifeType
    /** Rag Enabled */
    rag_enabled?: boolean | null
}

/** ExternalUploadDTO */
export interface ExternalUploadDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /**
     * Source Url
     * @format uri
     * @minLength 1
     * @maxLength 2083
     */
    source_url: string
    /** Out Url */
    out_url: string | null
    /** External Id */
    external_id: string | null
    status: ExternalUploadStatus
    /** Status Description */
    status_description: string | null
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
}

/** ExternalUploadListOutputDTO */
export interface ExternalUploadListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: ExternalUploadDTO[]
}

/** ExternalUploadModel */
export interface ExternalUploadModel {
    /**
     * Source Url
     * @format uri
     * @minLength 1
     * @maxLength 2083
     */
    source_url: string
}

/** ExternalUploadStatus */
export enum ExternalUploadStatus {
    PROCESSING = 'PROCESSING',
    ERROR = 'ERROR',
    READY = 'READY',
}

/** File */
export interface File {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Filename */
    filename: string
    /** Size */
    size: number
    /** Total Count */
    total_count: number | null
    /** Url */
    url: string | null
    /**
     * Last Modified
     * @format date-time
     */
    last_modified: string
    /** Rag Enabled */
    rag_enabled: boolean | null
    /** Prefix */
    prefix: string
    /** @default "file" */
    object_type?: ObjectType
}

/** FileInfo */
export interface FileInfo {
    /** Filename */
    filename: string
    /** Total Count */
    total_count: number
}

/** FileLifeType */
export enum FileLifeType {
    PERMANENT = 'PERMANENT',
    TEMPORARY = 'TEMPORARY',
}

/** FileObjectDeleteByPrefixOutputDTO */
export interface FileObjectDeleteByPrefixOutputDTO {
    /** Success */
    success: boolean
}

/** FileObjectDeleteOutputDTO */
export interface FileObjectDeleteOutputDTO {
    /** Success */
    success: boolean
}

/** FileObjectIndexModel */
export interface FileObjectIndexModel {
    /** Prefix */
    prefix: string
    /** Rag Enabled */
    rag_enabled: boolean
}

/** FileObjectIndexOutputDTO */
export interface FileObjectIndexOutputDTO {
    /** Success */
    success: boolean
}

/** FileObjectMetadataUpdateOutputDTO */
export interface FileObjectMetadataUpdateOutputDTO {
    /** Success */
    success: boolean
    /** User Uuid */
    user_uuid?: string | null
    /** Filename */
    filename?: string | null
    /** Size */
    size?: number | null
    /** Last Modified */
    last_modified?: string | null
    /** Prefix */
    prefix?: string | null
    /** Rag Enabled */
    rag_enabled?: boolean | null
    /** Url */
    url?: string | null
}

/** FileObjectMoveModel */
export interface FileObjectMoveModel {
    /** Prefix */
    prefix: string
    /** Destination */
    destination: string
}

/** FileObjectPresignPostOutputDTO */
export interface FileObjectPresignPostOutputDTO {
    /** Url */
    url: string | null
    /** Fields */
    fields: Record<string, any> | null
    /** Future Url */
    future_url: string | null
    error?: S3StorageRepositoryErrors | null
}

/** FileObjectStorageInfoOutputDTO */
export interface FileObjectStorageInfoOutputDTO {
    /** Storage Size Mb */
    storage_size_mb: number
    /** Storage Size */
    storage_size: number
    /** Rag Size Mb */
    rag_size_mb: number
    /** Rag Size */
    rag_size: number
}

/** FileObjectUpdateMetaModel */
export interface FileObjectUpdateMetaModel {
    /** Prefix */
    prefix: string
    /** Rag Enabled */
    rag_enabled: boolean
}

/** FileObjectUserFolderOutputDTO */
export interface FileObjectUserFolderOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Files */
    files: File[]
    /** Folders */
    folders: Folder[]
    error?: S3StorageRepositoryErrors | null
}

/** Folder */
export interface Folder {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Filename */
    filename: string
    /** Size */
    size: number
    /** Total Count */
    total_count: number | null
    /** Url */
    url: string | null
    /**
     * Last Modified
     * @format date-time
     */
    last_modified: string
    /** Rag Enabled */
    rag_enabled: boolean | null
    /** Prefix */
    prefix: string
    /** @default "folder" */
    object_type?: ObjectType
}

/** FolderCreateModel */
export interface FolderCreateModel {
    /** Prefix */
    prefix: string
    life_type: FileLifeType
}

/** FolderCreateOutputDTO */
export interface FolderCreateOutputDTO {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Items Count */
    items_count: number
    /** Prefix */
    prefix: string
    error?: S3StorageRepositoryErrors | null
}

/** GetAllUserFoldersOutputDTO */
export interface GetAllUserFoldersOutputDTO {
    /** Files */
    files: FileInfo[]
    error?: S3StorageRepositoryErrors | null
}

/** HTTPValidationError */
export interface HTTPValidationError {
    /** Detail */
    detail?: ValidationError[]
}

/** ObjectType */
export enum ObjectType {
    File = 'file',
    Folder = 'folder',
}

/** S3StorageRepositoryErrors */
export enum S3StorageRepositoryErrors {
    FileAlreadyExistsError = 'FileAlreadyExistsError',
    S3ClientErrorError = 'S3ClientErrorError',
    FileNotFoundError = 'FileNotFoundError',
    UnExpectedError = 'UnExpectedError',
}

/** SortingField */
export enum SortingField {
    Filename = 'filename',
    LastModified = 'last_modified',
    Size = 'size',
}

/** UserFolderMoveOutputDTO */
export interface UserFolderMoveOutputDTO {
    /** Success */
    success: boolean
    error?: S3StorageRepositoryErrors | null
}

/** ValidationError */
export interface ValidationError {
    /** Location */
    loc: (string | number)[]
    /** Message */
    msg: string
    /** Error Type */
    type: string
}

export interface FoPresignPostApiV1UserFolderFileObjectPresignPostPostParams {
    /** File Object Presign Post Uc */
    file_object_presign_post_uc?: any
}

export interface FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetParams {
    /**
     * Life Type
     * Life type
     * @default "PERMANENT"
     */
    life_type?: FileLifeType | null
    /** File Object Storage Info Uc */
    file_object_storage_info_uc?: any
}

export interface FoUserFolderApiV1UserFolderFileObjectGetParams {
    /**
     * Prefix
     * prefix
     */
    prefix?: string | null
    /**
     * Object Type
     * Object type
     */
    object_type?: ObjectType | null
    /**
     * Order By
     * Sort by
     */
    order_by?: SortingField | null
    /**
     * Desc
     * Is desc sort
     */
    desc?: boolean | null
    /**
     * Limit
     * Limit
     * @default 100
     */
    limit?: number | null
    /**
     * Offset
     * Offset
     * @default 0
     */
    offset?: number | null
    /**
     * Life Type
     * Life type
     * @default "PERMANENT"
     */
    life_type?: FileLifeType | null
    /** File Object User Folder Uc */
    file_object_user_folder_uc?: any
}

export interface FoUserFoldersDeleteApiV1UserFolderFileObjectDeleteParams {
    /**
     * Prefix
     * prefix
     */
    prefix?: string | null
    /** File Object Delete Uc */
    file_object_delete_uc?: any
}

export interface DeleteUserFileByPrefixApiV1UserFolderFileObjectByPrefixPostParams {
    /** File Object Delete By Prefix Uc */
    file_object_delete_by_prefix_uc?: any
}

export interface DeleteUserDataApiV1UserFolderFileObjectUserPostParams {
    /**
     * Prefix
     * @default "/"
     */
    prefix?: string | null
    /** File Object Delete Uc */
    file_object_delete_uc?: any
}

export interface IndexFileApiV1UserFolderFileObjectIndexPostParams {
    /** File Object Index Uc */
    file_object_index_uc?: any
}

export interface UpdateMetadataForFileApiV1UserFolderFileObjectUpdateMetaPostParams {
    /** File Object Metadata Update Uc */
    file_object_metadata_update_uc?: any
}

export interface MoveUserObjectApiV1UserFolderMovePostParams {
    /** User Folder Move Uc */
    user_folder_move_uc?: any
}

export interface CreateFolderApiV1UserFolderFolderPostParams {
    /** Folder Create Uc */
    folder_create_uc?: any
}

export interface GetAllUserFoldersApiV1UserFolderFolderGetParams {
    /**
     * Prefix
     * prefix
     */
    prefix?: string | null
    /**
     * Order By
     * Sort by
     */
    order_by?: SortingField | null
    /**
     * Desc
     * Is desc sort
     */
    desc?: boolean | null
    /**
     * Life Type
     * Life type
     * @default "PERMANENT"
     */
    life_type?: FileLifeType | null
    /**
     * Exclude Prefix
     * Exclude prefix
     */
    exclude_prefix?: string | null
    /** Get All User Folders Uc */
    get_all_user_folders_uc?: any
}

export interface EuCreateApiV1UserFolderExternalUploadPostParams {
    /** External Upload Start Uc */
    external_upload_start_uc?: any
}

export interface EuListApiV1UserFolderExternalUploadGetParams {
    /** External Upload List Uc */
    external_upload_list_uc?: any
}

export interface EuStatusApiV1UserFolderExternalUploadExternalUploadIdGetParams {
    /** External Upload Status Uc */
    external_upload_status_uc?: any
    /**
     * External Upload Id
     * @format uuid
     */
    externalUploadId: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean
    /** request path */
    path: string
    /** content type of request body */
    type?: ContentType
    /** query params */
    query?: QueryParamsType
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat
    /** request body */
    body?: unknown
    /** base url */
    baseUrl?: string
    /** request cancellation token */
    cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
    securityWorker?: (
        securityData: SecurityDataType | null,
    ) => Promise<RequestParams | void> | RequestParams | void
    customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D
    error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = ''
    private securityData: SecurityDataType | null = null
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
    private abortControllers = new Map<CancelToken, AbortController>()
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    }

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig)
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data
    }

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key)
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key])
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key]
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {}
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
        return keys
            .map((key) =>
                Array.isArray(query[key])
                    ? this.addArrayQueryParam(query, key)
                    : this.addQueryParam(query, key),
            )
            .join('&')
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery)
        return queryString ? `?${queryString}` : ''
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string')
                ? JSON.stringify(input)
                : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key]
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                          ? JSON.stringify(property)
                          : `${property}`,
                )
                return formData
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    }

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        }
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken)
            if (abortController) {
                return abortController.signal
            }
            return void 0
        }

        const abortController = new AbortController()
        this.abortControllers.set(cancelToken, abortController)
        return abortController.signal
    }

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken)

        if (abortController) {
            abortController.abort()
            this.abortControllers.delete(cancelToken)
        }
    }

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {}
        const requestParams = this.mergeRequestParams(params, secureParams)
        const queryString = query && this.toQueryString(query)
        const payloadFormatter = this.contentFormatters[type || ContentType.Json]
        const responseFormat = format || requestParams.format

        return this.customFetch(
            `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
            {
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
                },
                signal:
                    (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) ||
                    null,
                body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
            },
        ).then(async (response) => {
            const r = response.clone() as HttpResponse<T, E>
            r.data = null as unknown as T
            r.error = null as unknown as E

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data
                          } else {
                              r.error = data
                          }
                          return r
                      })
                      .catch((e) => {
                          r.error = e
                          return r
                      })

            if (cancelToken) {
                this.abortControllers.delete(cancelToken)
            }

            if (!response.ok) throw data
            return data
        })
    }
}

/**
 * @title FastAPI
 * @version 0.1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    ping = {
        /**
         * No description
         *
         * @tags Ping
         * @name PingPingGet
         * @summary Ping
         * @request GET:/ping
         */
        pingPingGet: (params: RequestParams = {}) =>
            this.request<Record<string, string>, any>({
                path: `/ping`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    }
    api = {
        /**
         * No description
         *
         * @tags User folder files
         * @name FoPresignPostApiV1UserFolderFileObjectPresignPostPost
         * @summary Fo Presign Post
         * @request POST:/api/v1/user_folder/file_object/presign_post
         */
        foPresignPostApiV1UserFolderFileObjectPresignPostPost: (
            query: FoPresignPostApiV1UserFolderFileObjectPresignPostPostParams,
            data: BodyFoPresignPostApiV1UserFolderFileObjectPresignPostPost,
            params: RequestParams = {},
        ) =>
            this.request<FileObjectPresignPostOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/file_object/presign_post`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder files
         * @name FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet
         * @summary Fo User Storage Info
         * @request GET:/api/v1/user_folder/file_object/storage_info
         */
        foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet: (
            query: FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetParams,
            params: RequestParams = {},
        ) =>
            this.request<FileObjectStorageInfoOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/file_object/storage_info`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder files
         * @name FoUserFolderApiV1UserFolderFileObjectGet
         * @summary Fo User Folder
         * @request GET:/api/v1/user_folder/file_object
         */
        foUserFolderApiV1UserFolderFileObjectGet: (
            query: FoUserFolderApiV1UserFolderFileObjectGetParams,
            params: RequestParams = {},
        ) =>
            this.request<FileObjectUserFolderOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/file_object`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder files
         * @name FoUserFoldersDeleteApiV1UserFolderFileObjectDelete
         * @summary Fo User Folders Delete
         * @request DELETE:/api/v1/user_folder/file_object
         */
        foUserFoldersDeleteApiV1UserFolderFileObjectDelete: (
            query: FoUserFoldersDeleteApiV1UserFolderFileObjectDeleteParams,
            params: RequestParams = {},
        ) =>
            this.request<FileObjectDeleteOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/file_object`,
                method: 'DELETE',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder files
         * @name DeleteUserFileByPrefixApiV1UserFolderFileObjectByPrefixPost
         * @summary Delete User File By Prefix
         * @request POST:/api/v1/user_folder/file_object/by_prefix
         */
        deleteUserFileByPrefixApiV1UserFolderFileObjectByPrefixPost: (
            query: DeleteUserFileByPrefixApiV1UserFolderFileObjectByPrefixPostParams,
            data: BodyDeleteUserFileByPrefixApiV1UserFolderFileObjectByPrefixPost,
            params: RequestParams = {},
        ) =>
            this.request<FileObjectDeleteByPrefixOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/file_object/by_prefix`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder files
         * @name DeleteUserDataApiV1UserFolderFileObjectUserPost
         * @summary Delete User Data
         * @request POST:/api/v1/user_folder/file_object/user
         */
        deleteUserDataApiV1UserFolderFileObjectUserPost: (
            query: DeleteUserDataApiV1UserFolderFileObjectUserPostParams,
            data: string[],
            params: RequestParams = {},
        ) =>
            this.request<FileObjectDeleteOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/file_object/user`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder files
         * @name IndexFileApiV1UserFolderFileObjectIndexPost
         * @summary Index File
         * @request POST:/api/v1/user_folder/file_object/index
         */
        indexFileApiV1UserFolderFileObjectIndexPost: (
            query: IndexFileApiV1UserFolderFileObjectIndexPostParams,
            data: FileObjectIndexModel,
            params: RequestParams = {},
        ) =>
            this.request<FileObjectIndexOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/file_object/index`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder files
         * @name UpdateMetadataForFileApiV1UserFolderFileObjectUpdateMetaPost
         * @summary Update Metadata For File
         * @request POST:/api/v1/user_folder/file_object/update_meta
         */
        updateMetadataForFileApiV1UserFolderFileObjectUpdateMetaPost: (
            query: UpdateMetadataForFileApiV1UserFolderFileObjectUpdateMetaPostParams,
            data: FileObjectUpdateMetaModel,
            params: RequestParams = {},
        ) =>
            this.request<FileObjectMetadataUpdateOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/file_object/update_meta`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Move user files
         * @name MoveUserObjectApiV1UserFolderMovePost
         * @summary Move User Object
         * @request POST:/api/v1/user_folder/move
         */
        moveUserObjectApiV1UserFolderMovePost: (
            query: MoveUserObjectApiV1UserFolderMovePostParams,
            data: FileObjectMoveModel,
            params: RequestParams = {},
        ) =>
            this.request<UserFolderMoveOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/move`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folders
         * @name CreateFolderApiV1UserFolderFolderPost
         * @summary Create Folder
         * @request POST:/api/v1/user_folder/folder
         */
        createFolderApiV1UserFolderFolderPost: (
            query: CreateFolderApiV1UserFolderFolderPostParams,
            data: FolderCreateModel,
            params: RequestParams = {},
        ) =>
            this.request<FolderCreateOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/folder`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folders
         * @name GetAllUserFoldersApiV1UserFolderFolderGet
         * @summary Get All User Folders
         * @request GET:/api/v1/user_folder/folder
         */
        getAllUserFoldersApiV1UserFolderFolderGet: (
            query: GetAllUserFoldersApiV1UserFolderFolderGetParams,
            params: RequestParams = {},
        ) =>
            this.request<GetAllUserFoldersOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/folder`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder external upload
         * @name EuCreateApiV1UserFolderExternalUploadPost
         * @summary Eu Create
         * @request POST:/api/v1/user_folder/external_upload
         */
        euCreateApiV1UserFolderExternalUploadPost: (
            query: EuCreateApiV1UserFolderExternalUploadPostParams,
            data: ExternalUploadModel,
            params: RequestParams = {},
        ) =>
            this.request<ExternalUploadDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/external_upload`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder external upload
         * @name EuListApiV1UserFolderExternalUploadGet
         * @summary Eu List
         * @request GET:/api/v1/user_folder/external_upload
         */
        euListApiV1UserFolderExternalUploadGet: (
            query: EuListApiV1UserFolderExternalUploadGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ExternalUploadListOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/external_upload`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User folder external upload
         * @name EuStatusApiV1UserFolderExternalUploadExternalUploadIdGet
         * @summary Eu Status
         * @request GET:/api/v1/user_folder/external_upload/{external_upload_id}
         */
        euStatusApiV1UserFolderExternalUploadExternalUploadIdGet: (
            {
                externalUploadId,
                ...query
            }: EuStatusApiV1UserFolderExternalUploadExternalUploadIdGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ExternalUploadDTO, HTTPValidationError>({
                path: `/api/v1/user_folder/external_upload/${externalUploadId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    }
}
